import { Dispatch } from 'redux';
import SignalSourceConfigurationsController from '../controllers/SignalSourceConfigurationsController';
import commonHandler from '../errorHandlers/common-handler';
import { SourceConfiguration } from '../model/SignalModel';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';

class SignalSourceConfigurationsCRUDActions extends CrudActionContainer {
  resetStore: string;

  constructor() {
    super('SIGNAL_SOURCE_CONFIGURATIONS');
    this.resetStore = this.makeActionKey('RESET_STORE');
  }

  update(data: Partial<SourceConfiguration> & { id: number }) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.updateAction));
        const response = await SignalSourceConfigurationsController.update(
          data,
        );
        dispatch(this.retrieved(response));
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  retrieveAll(configurationId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));

      try {
        const response = await SignalSourceConfigurationsController.getAll(
          configurationId,
        );
        dispatch(this.retrievedAll(response));

        return response;
      } catch (error) {
        return commonHandler(dispatch)(error);
      }
    };
  }

  invalidateStore() {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch({ type: this.resetStore });
    };
  }
}

const signalSourceConfigurationsCRUDActions =
  new SignalSourceConfigurationsCRUDActions();

export default signalSourceConfigurationsCRUDActions;

export const useSignalSourceConfigurationsCRUDActions = getActionHookBuilder(
  signalSourceConfigurationsCRUDActions,
  ['retrieveAll', 'update', 'invalidateStore'],
);
